import { Search, X } from "lucide-react";
import { searchBar } from "@web/theme/theme";

export type SearchBarProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  label?: string;
  autoFocus?: boolean;
  className?: string;
};

export function SearchBar({ value, onChange, placeholder = "Search", label = "Search", autoFocus, className = "" }: SearchBarProps) {
  return (
    <div className={`${searchBar.wrap} ${className}`.trim()}>
      <Search aria-hidden size={18} className={searchBar.icon} />
      <input
        type="search"
        role="searchbox"
        aria-label={label}
        placeholder={placeholder}
        value={value}
        autoFocus={autoFocus}
        enterKeyHint="search"
        autoComplete="off"
        onChange={(e) => onChange(e.target.value)}
        className={searchBar.input}
      />
      {value && (
        <button type="button" aria-label="Clear search" onClick={() => onChange("")} className={searchBar.clear}>
          <X aria-hidden size={18} />
        </button>
      )}
    </div>
  );
}
